import { Button, Typography } from 'antd'
import React, { forwardRef, RefAttributes, useCallback, useImperativeHandle, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ActionConfirmationModal from 'src/app/shared/components/modal/action-confirmation-modal'
import { AlertIcon } from 'src/assets/icons'

interface PayeeMatchWarningModalProps {}

export interface PayeeMatchWarningRef {
  hide: () => void
  show: () => void
}

export const payeeMatchWarningRef = React.createRef<PayeeMatchWarningRef>()

const PayeeMatchWarningModal: React.FC<RefAttributes<PayeeMatchWarningRef> & PayeeMatchWarningModalProps> = forwardRef<
  PayeeMatchWarningRef,
  PayeeMatchWarningModalProps
>((_, ref) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState<boolean>(false)
  const hide = useCallback(() => setOpen(false), [])
  const show = useCallback(() => setOpen(true), [])

  useImperativeHandle(ref, () => ({
    hide,
    show,
  }))

  return (
    <ActionConfirmationModal
      title={t('common:warning')}
      descriptionType='string'
      description={
        <center>
          <div className='description-container'>
            <Typography className='description'>
              {t('AccountSetup:new_account_form.title.payeeMatchWarning')}
            </Typography>
            <Typography className='description'>{t('AccountSetup:new_account_form.title.payeeMatchReview')}</Typography>
          </div>
        </center>
      }
      onClose={hide}
      isOpen={open}
      icon={<AlertIcon width={80} height={80} />}
      footer={[
        <Button type='primary' key={'confirm'} onClick={hide}>
          {t('common:ok').toUpperCase()}
        </Button>,
      ]}
    ></ActionConfirmationModal>
  )
})

export default PayeeMatchWarningModal
